// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Zmtx","rootSuccess":"CompleteLink_rootSuccess__1g3_u","rootFailure":"CompleteLink_rootFailure__2x8Vw","isDisabled":"CompleteLink_isDisabled__2x6UE"};